import React from 'react';
import { Edit, ListButton, TopToolbar } from 'react-admin';
import FranchiseForm from './FranchiseForm';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

const FranchiseActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const FranchiseEdit = (props) => {
  return (
    <Edit actions={<FranchiseActions {...props} />} {...props}>
      <FranchiseForm />
    </Edit>
  );
};

export default FranchiseEdit;
